import { Component, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { MenuDynamicBody } from '@veritas-core/models/menu-output';
import { MenuService } from '@veritas-core/services/menu.service';
import { SessionService } from '@veritas-shared/services/session.service';
import { map, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-dynamic',
  templateUrl: './dynamic.component.html',
  styleUrls: ['./dynamic.component.scss']
})
export class DynamicComponent implements OnDestroy {
  public menuBody?: MenuDynamicBody;
  public content?: SafeHtml;

  constructor(
    private readonly menuService: MenuService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly sanitizer: DomSanitizer,
    private readonly sessionService: SessionService,
  ){}

  ngOnDestroy(): void {
    this.menuBody$.unsubscribe();
  }

  private menuBody$ = this.activatedRoute.paramMap.pipe(
    map((param: ParamMap) => {
      const childId = param?.get('childId');
      if (!childId) return 0;
      return parseInt(childId, 10);
    }),
    switchMap((childId: number) => this.menuService.getDynamicBody(childId))
  ).subscribe({
    next: (body: MenuDynamicBody) => {
      this.sessionService.setPageTitle(body?.title);
      // TODO check it: bypassSecurityTrustHtml remove security check, can we NOT use it with final src content embedding 
      this.content = this.sanitizer.bypassSecurityTrustHtml(body?.content);
      this.menuBody = body;
    },
    error: () => { this.menuBody = null; }
  })
}
